import React, { useState, useEffect } from 'react';
import {
    Grid,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    makeStyles,
    TextField,
    Paper,
    Divider, // Import Paper component
} from '@material-ui/core';
import { useDispatch } from "react-redux";
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from "react-i18next";
import { Autocomplete } from '@material-ui/lab';
import { getUserPreference } from "../../../../utilities/common";
import {
    updateKeyAccount,
    deleteKeyAccount,
} from "../../../../actions/incidentManagementActions";
import FullscreenLoading from '../../../Common/FullscreenLoading';
import { showAlertSnackbar } from '../../../../reducers/uiSlice';

const useStyles = makeStyles((theme) => ({
    dialogContent: {
        display: 'flex',
        justifyContent: 'space-between',
        scrollbarWidth: 'none', /* Firefox  */
        '-ms-overflow-style': 'none', /* Internet Explorer  */
        '&::-webkit-scrollbar': {
            width: 0,
            height: 0,
        },
    },
    dialogActions: {
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(1),
        justifyContent: 'flex-end',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
    },
    deleteButton: {
        position: 'absolute',
        marginLeft: theme.spacing(4),
    },
    deleteButton: {
        marginLeft: theme.spacing(2.5),
    },
    dialogPaper: {
        width: '600px', // Set the desired width
        minHeight: 'flex', // Set the desired height
    },
    grid: {
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'left',
        flexDirection: 'row',
        marginTop: theme.spacing(2), // 调整上方间距
        marginBottom: theme.spacing(-1), // 调整下方间距
    },
    textField: {
        margin: "5px"
    },
    root: {
        flexGrow: 1,
    },
}));

function KeyAccountUpdateDialog({ open, onClose, partnerList, selectedData, handleSearch }) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { t } = useTranslation('incidentmanagement');
    const userPref = getUserPreference();
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [viewOnly, setViewOnly] = useState(false);
    const [name, setName] = useState('');
    const [phone, setPhone] = useState(null);
    const [email, setEmail] = useState('');
    const [dingTalk, setDingTalk] = useState('');
    const [partners, setPartners] = useState([]);
    const [isCreateDisabled, setIsCreateDisabled] = useState(true); // 添加用于禁用按钮的状态
    const [id, setId] = useState('');

    useEffect(() => {
        let dataToShow = selectedData;
        if (Array.isArray(selectedData)) {
            dataToShow = selectedData[0];
            setViewOnly(true);
        }

        if (dataToShow) {
            setId(dataToShow.id || '');
            setName(dataToShow.name || '');
            setPhone(dataToShow.phone || null);
            setEmail(dataToShow.email || '');
            setDingTalk(dataToShow.ding_talk_id || '');

            if (dataToShow.partners && typeof dataToShow.partners === 'string' && partnerList) {
                // Split the string into an array
                const partnerNamesArray = dataToShow.partners.split(',');

                const partnerIds = partnerNamesArray.map(partnerName => {
                    const foundPartner = partnerList.find(p => p.name === partnerName.trim());
                    return foundPartner ? foundPartner.id : null;
                }).filter(Boolean); // Removes null values (in case a partner name doesn't match)

                setPartners(partnerIds);
            }
        }
    }, [selectedData, partnerList]);



    const handleClose = () => {
        onClose();
    };

    const handleSave = () => {
        setIsDataLoading(true);
        const params = {
            id: id,
            name: name.trim(),
            phone: phone || '',
            email: email.trim(),
            ding_talk_id: dingTalk || '',
            warehouse: userPref.userCity || '',
            partner_ids: partners || [],
        };

        if (params.name === '' || params.phone === 0 || params.email === '') {
            dispatch(showAlertSnackbar({
                title: t('incident_management'),
                message: t('fields_required'),
                type: 'error'
            }));
            setIsDataLoading(false); // 停止加载状态
            return;
        }

        dispatch(updateKeyAccount(params))
            .then((response) => {
                if (response.status === 'FAIL') {
                    dispatch(showAlertSnackbar({
                        title: t('incident_management'),
                        message: response.retMsg,
                        type: 'error'
                    }));
                } else {
                    dispatch(showAlertSnackbar({
                        title: t('incident_management'),
                        message: t('update_success'),
                        type: 'success'
                    }));
                    handleSearch();
                    handleClose();
                }
            })
            .catch((error) => {
                dispatch(showAlertSnackbar({
                    title: t('incident_management'),
                    message: t('create_failed'),
                    type: 'error'
                }));
            })
            .finally(() => {
                setIsDataLoading(false);
            });
    };

    const handleDelete = () => {
        setIsDataLoading(true);
        const params = {
            id: id,
            user_id: userPref.userId,
        };
        dispatch(deleteKeyAccount(params))
            .then((response) => {
                if (response.status === 'FAIL') {
                    dispatch(showAlertSnackbar({
                        title: t('incident_management'),
                        message: response.retMsg,
                        type: 'error'
                    }));
                } else {
                    dispatch(showAlertSnackbar({
                        title: t('incident_management'),
                        message: t('delete_success'),
                        type: 'success'
                    }));
                }
            })
            .catch((error) => {
                dispatch(showAlertSnackbar({
                    title: t('incident_management'),
                    message: t('delete_failed'),
                    type: 'error'
                }));
            })
            .finally(() => {
                setIsDataLoading(false);
                handleSearch();
                handleClose();
            });
    };

    useEffect(() => {
        setIsCreateDisabled(
            (typeof name !== 'string' || name.trim() === '') ||
            (typeof email !== 'string' || email.trim() === '') ||
            phone === 0
        );
    }, [name, phone, email]);

    return (
        <Dialog open={open} onClose={handleClose} classes={{ paper: classes.dialogPaper }}>
            <DialogTitle>
                {t('update_key_account')}
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <div className={classes.root}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Divider></Divider>
                        </Grid>
                        <Grid item xs={4} className={classes.grid}>
                            <TextField
                                id="name_textfield"
                                className={classes.textField}
                                value={name}
                                label={t('name')}
                                name="phone"
                                variant="outlined"
                                onChange={(e) => setName(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={4} className={classes.grid}>
                            <TextField
                                id="phone_number_textfield"
                                className={classes.textField}
                                label={t('phone')}
                                value={phone}
                                name="phone"
                                variant="outlined"
                                onChange={(e) => setPhone(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={4} className={classes.grid}>
                            <TextField
                                id="email_textfield"
                                className={classes.textField}
                                label={t('email')}
                                value={email}
                                name="email"
                                variant="outlined"
                                onChange={(e) => setEmail(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={4} className={classes.grid}>
                            <TextField
                                id="dingtalk_textfield"
                                className={classes.textField}
                                value={dingTalk}
                                label={t('ding_talk_id')}
                                name="ding_talk_id"
                                variant="outlined"
                                onChange={(e) => setDingTalk(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={8} className={classes.grid}>
                            <Autocomplete
                                className={classes.textField}
                                options={partnerList}
                                getOptionLabel={(option) => option?.name}
                                limitTags={4}
                                multiple
                                onChange={(event, value) => {
                                    setPartners(value.map((item) => item.id));
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label={t("partner")} variant="outlined" />
                                )}
                                id="advancedsearch_autocomplete"
                                value={partners ? partnerList.filter((option) => partners.includes(option.id)) : []}
                                fullWidth
                                margin="normal"
                            />

                        </Grid>
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button
                    className={classes.deleteButton}
                    variant="contained"
                    color="secondary"
                    onClick={handleDelete}
                    disabled={viewOnly}
                >
                    {t("common:delete")}
                </Button>
                <div style={{ flex: 1 }} />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                    disabled={isCreateDisabled || viewOnly}
                >
                    {t("common:save")}
                </Button>
            </DialogActions>
            <FullscreenLoading open={isDataLoading} />
        </Dialog>

    );
}

export default KeyAccountUpdateDialog;
